import { render, staticRenderFns } from "./ChipsFilters.vue?vue&type=template&id=3eb6c982&"
import script from "./ChipsFilters.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ChipsFilters.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3eb6c982')) {
      api.createRecord('3eb6c982', component.options)
    } else {
      api.reload('3eb6c982', component.options)
    }
    module.hot.accept("./ChipsFilters.vue?vue&type=template&id=3eb6c982&", function () {
      api.rerender('3eb6c982', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/lpu/components/ChipsFilters/ChipsFilters.vue"
export default component.exports